var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEditorOrderedList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01058 4.06254H17.9168M9.01058 10H17.9168M10.0002 15.9375H17.9168M2.0835 13.9584C2.0835 13.4335 2.29201 12.9301 2.66318 12.5589C3.03435 12.1877 3.53775 11.9792 4.06266 11.9792C4.58757 11.9792 5.09098 12.1877 5.46214 12.5589C5.83331 12.9301 6.04183 13.4335 6.04183 13.9584C6.04183 14.5432 5.54704 14.948 5.05225 15.4427L2.0835 17.9167H6.04183M4.06266 8.02087V2.08337L2.0835 4.06254",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEditorOrderedList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-editor-ordered-list.a2913e7dda1f62dabbd4520bd14245ee.svg";